export default __webpack_public_path__ + "static/media/Group 1388.bb3c98e4.svg";